import { useEffect, useRef, useState } from "react";

/**
 * Rascunho automático de formulários (PDF Fase 02 — #9/#10): persiste o estado
 * do form no localStorage enquanto a pessoa preenche, pra não perder nada se
 * sair sem querer (ex.: foi cadastrar um tipo de tarefa no meio do caminho).
 *
 * - `ativo`: só persiste quando true (ex.: criação, não edição).
 * - Retorna o rascunho encontrado no mount (pra oferecer "restaurar"), uma função
 *   `salvar` chamada a cada mudança, e `limpar` (chamar no submit com sucesso).
 */
export function useRascunho<T>(chave: string, ativo: boolean) {
  const storageKey = `rascunho_${chave}`;
  // Lê uma vez no mount (não reage a mudanças externas do storage).
  const rascunhoInicialRef = useRef<T | null>(null);
  const [temRascunho, setTemRascunho] = useState(false);

  useEffect(() => {
    if (!ativo) return;
    try {
      const raw = localStorage.getItem(storageKey);
      if (raw) {
        rascunhoInicialRef.current = JSON.parse(raw) as T;
        setTemRascunho(true);
      }
    } catch { /* ignora */ }
    // só no mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function salvar(valor: T) {
    if (!ativo) return;
    try { localStorage.setItem(storageKey, JSON.stringify(valor)); } catch { /* ignora */ }
  }
  function limpar() {
    try { localStorage.removeItem(storageKey); } catch { /* ignora */ }
    setTemRascunho(false);
  }
  function descartar() {
    rascunhoInicialRef.current = null;
    limpar();
  }

  return { rascunhoInicial: rascunhoInicialRef.current, temRascunho, salvar, limpar, descartar };
}
